import '../scss/app.scss';

import reCaptcha from './components/reCaptcha';
import Contact from './components/contact.js';

import { initNavigation } from './components/navigation.js';

document.addEventListener('DOMContentLoaded', () => {
    reCaptcha.init();

    initNavigation();

    const contactForm = document.getElementById('contact-us-form');

    if (contactForm) {
        Contact.init();
    }
});
